module.exports = __webpack_public_path__ + "img/logo.6abb2e61.png";